import { render, staticRenderFns } from "./CopyStructDialog.vue?vue&type=template&id=52ebdd5a&scoped=true&lang=pug&"
import script from "./CopyStructDialog.vue?vue&type=script&lang=js&"
export * from "./CopyStructDialog.vue?vue&type=script&lang=js&"
import style0 from "./CopyStructDialog.vue?vue&type=style&index=0&id=52ebdd5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ebdd5a",
  null
  
)

export default component.exports